export default "__VITE_ASSET__CeNPxAhL__"